import React from 'react';
import { Icon } from '#app/components/ui/icon.tsx';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '#app/components/ui/select.tsx';
import { EXPORT_TARGETS } from '#app/constants.ts';
import { type WidgetCardProps } from '#app/routes/widgets+/__widget-types.ts';
import { cn } from '#app/utils/misc.tsx';

export function WidgetCard({
  id,
  title,
  legend,
  data,
  children,
  readonly,
  showExport,
  widgetType,
  onSelectExport,
  titleClassName,
}: WidgetCardProps<any>) {
  return (
    <div className="relative w-full">
      <div className="flex items-center justify-between gap-x-4 overflow-hidden pb-12 pt-1">
        <h2
          className={cn(
            'text-lg capitalize',
            {
              'max-w-[200px]': !readonly && showExport,
              'max-w-[350px]': readonly || !showExport,
            },
            titleClassName,
          )}
        >
          {title}
        </h2>
        <div className="flex flex-1 items-center justify-end gap-x-4 pr-2">
          {legend}
          {!readonly && showExport && (
            <Select
              value=""
              onValueChange={
                onSelectExport
                  ? (value) => onSelectExport(widgetType, id, value, data)
                  : undefined
              }
            >
              <SelectTrigger className="w-auto p-0 pr-2">
                <div className="flex items-baseline border-r py-2 pl-2 pr-4">
                  <Icon name="download" className="mr-2 h-5 w-5" />
                  <SelectValue className="block" placeholder="Exportar" />
                </div>
              </SelectTrigger>
              <SelectContent>
                {EXPORT_TARGETS.map((target) => (
                  <SelectItem key={target.value} value={target.value}>
                    {target.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
